import { useEffect } from 'react';

/**
 * Adds the `in` class to every `.reveal` element as it scrolls into view,
 * so CSS can drive staggered entrance animations without any dependency.
 *
 * Re-runs whenever `deps` change, so freshly rendered nodes get observed too.
 */
export default function useReveal(deps = []) {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll('.reveal:not(.in)'));
    if (nodes.length === 0) return undefined;

    // No IntersectionObserver (or reduced motion) → just show everything.
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || typeof IntersectionObserver === 'undefined') {
      nodes.forEach((n) => n.classList.add('in'));
      return undefined;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
